import { Button, Container, Group, Stack, Text } from "@mantine/core";

type Pagina4Properties = {
  categoriaVotada: string;
  onVotarNovamente: () => void;
  onFinalizar: () => void;
};

const Pagina4 = ({ categoriaVotada, onVotarNovamente, onFinalizar }: Pagina4Properties) => {
  return (
    <Container size="sm" py="xl">
      <Stack align="center">
        <Text size="xl" fw={600}>
          Obrigado pelo seu voto na categoria {categoriaVotada}!
        </Text>
        <Text size="md">Se quiser continuar votando em outra categoria, fique à vontade!</Text>
        <Group mt="md">
          <Button variant="outline" onClick={onVotarNovamente}>
            Votar em outra categoria
          </Button>
          <Button onClick={onFinalizar}>Finalizar</Button>
        </Group>
      </Stack>
    </Container>
  );
};

export default Pagina4;
